import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { LkpBanksModel } from 'src/app/models/LkpBanksModel';
import { LkpBanksService } from 'src/app/services/LkpBanksService';
import swal from 'sweetalert2';
import { BankSearchComponent } from '../bank-search/bank-search.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-banks-settings',
  templateUrl: './banks-settings.component.html',
  styleUrls: ['./banks-settings.component.css']
})
export class BanksSettingsComponent implements OnInit {
  bnkcode ='';
  bnkname ='';
  bnknotes ='';
  bnkaccount ='';
  bnkopenbalance =0;
  bnkcurrency ='';
  bnkrate =0;
  bankopentype ='';
  bnkDefult = false;
  compcode = '1';
  userid ='sa';
  modifieddate = '2022-01-01';
  constructor(private dialogref: MatDialog,
              public translate: TranslateService,
              public bankservice : LkpBanksService,
              public bank : LkpBanksModel,
              public storage: LocalStorageService,) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  RetriveBank(){
    this.bankservice.getBank(this.bnkcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpBanksModel) => {

        this.bnkname = data.bnkname;
        this.bnknotes = data.bnknotes;
        this.userid = data.userid;
        this.modifieddate = data.modifieddate;
        this.compcode = data.compcode;

      }
    );
  }
  OpenDialog(){
    const dialogRef = this.dialogref.open(BankSearchComponent,
      {
        data: {
          dataKey: this.bank
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.bnkcode = result.bnkcode;
        this.bnkname = result.bnkname;
        this.bnknotes = result.bnknotes;
        this.bnkaccount = result.bnkaccount;
        this.bankopentype = result.bankopentype;
        this.bnkDefult = result.bnkDefult;

        this.RetriveBank();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  SubmitBank(){
    if (this.bnkcode == '' || this.bnkcode == null) {
      return;
    }

    this.bank.bnkcode = this.bnkcode;
    this.bank.bnkname = this.bnkname;
    this.bank.bnknotes = this.bnknotes;
    this.bank.bnkaccount = this.bnkaccount;
    this.bank.bnkopenbalance = this.bnkopenbalance;
    this.bank.bnkcurrency = 'LE';
    this.bank.bnkrate = 1;
    this.bank.bankopentype = this.bankopentype;
    this.bank.bnkDefult = this.bnkDefult;

    this.bank.userid = this.storage.retrieve('stguserId');
    this.bank.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.bank.compcode = this.storage.retrieve('stgcompcode');
    this.bankservice.AddBank(this.bank).subscribe(data => {
    this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  DeleteBank(){
    this.bankservice.DelBank(this.bnkcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpBanksModel) => {
      }
    );
    this.NewData();
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteBank();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  NewData(){
      this.bnkcode ='';
      this.bnkname ='';
      this.bnknotes ='';
      this.bnkaccount ='';
      this.bnkopenbalance =0;
      this.bnkcurrency ='';
      this.bnkrate =0;
      this.bankopentype ='';
      this.bnkDefult = false;
      this.compcode = '1';
      this.userid ='sa';
      this.modifieddate = '2022-01-01';
  }
  mesgSave() {
    swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

}
